import React from 'react';
import { address, SetupIntentResponse } from '../StripePaymentInterface';
import { Stripe } from '@stripe/stripe-js';
import { LoadingIndicator } from 'src/latest/src';
import { Elements } from '@stripe/react-stripe-js';
import StripeCard from './StripeCard/StripeCard';
import { useTranslation } from 'react-i18next';
import { User } from 'src/latest/src/components/UserProfileHeader/types';

interface StripeUpdateProps {
  setupIntent: SetupIntentResponse | null;
  stripePromise: Promise<Stripe | null> | null;
  onToken?: (status: string, choice: any) => void;
  choice: any;
  handleCardUpdated: () => void;
  accountAddress: address;
  responsiblePartyAccountAddress: any;
  fromOnboarding: boolean;
  userData: User | null;
  handleLeftArrowClick: () => void;
  hideBackButton: boolean;
  isDirectoryPlatform: boolean;
  onStripeProcessingChange?: (isProcessing: boolean) => void;
}

const StripeUpdate: React.FC<StripeUpdateProps> = ({
  setupIntent,
  stripePromise,
  onToken,
  choice,
  handleCardUpdated,
  accountAddress,
  responsiblePartyAccountAddress,
  fromOnboarding,
  userData,
  handleLeftArrowClick,
  hideBackButton,
  isDirectoryPlatform,
  onStripeProcessingChange,
}) => {
  const { t } = useTranslation('stripePayment');

  return (
    <>
      {setupIntent && stripePromise ? (
        <div>
          <Elements
            stripe={stripePromise}
            options={{
              clientSecret: setupIntent.client_secret,
              appearance: {
                theme: 'stripe',
                variables: {
                  colorPrimary: '#6366f1',
                },
              },
            }}
          >
            <StripeCard
              clientSecret={setupIntent.client_secret}
              clientPaymentProfileId={setupIntent.client_payment_profile_id}
              onToken={onToken}
              choice={choice}
              buttonLabel={t('stripeUpdate.buttonLabel.update')}
              onCardUpdated={handleCardUpdated}
              fromAddScreen={false}
              accountAddress={accountAddress}
              responsiblePartyAccountAddress={responsiblePartyAccountAddress}
              fromOnboarding={fromOnboarding}
              userData={userData}
              handleLeftArrowClick={handleLeftArrowClick}
              hideBackButton={hideBackButton}
              isDirectoryPlatform={isDirectoryPlatform}
              onProcessingChange={onStripeProcessingChange}
            />
          </Elements>
        </div>
      ) : (
        <LoadingIndicator loading={true} />
      )}
    </>
  );
};

export default StripeUpdate;
